import { useQuery } from '@tanstack/react-query';

import { getCurrency } from '@entities/currency/api/getCurrency';
import { TCurrencyList } from '@entities/currency/model/types';
import { keysToCamel } from '@shared/helpers/snakeToCamel';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const useGetCurrencyQuery = () => {
    const {
        isLoading: isGetCurrencyLoading,
        isFetching,
        data,
        isSuccess,
    } = useQuery<IDataResponse<TCurrencyList>, Error, TCurrencyList>({
        queryKey: ['getCurrency'],
        queryFn: getCurrency,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        select: (response: IDataResponse<TCurrencyList>) => keysToCamel(response.data),
    });

    return { isGetCurrencyLoading, isFetching, isSuccess, data };
};
